module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Image Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I should like to thank the following for kindly giving permission for the use of the images in this book:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Salvation Army International Heritage Centre, William Booth College, London")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_5"
    }
  }, [_vm._v("5")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_6"
    }
  }, [_vm._v("6")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_8"
    }
  }, [_vm._v("8")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Salvation Army Historical Centre, USA Southern Territory, Atlanta, USA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_2"
    }
  }, [_vm._v("2")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_3"
    }
  }, [_vm._v("3")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_4"
    }
  }, [_vm._v("4")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_7"
    }
  }, [_vm._v("7")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_9"
    }
  }, [_vm._v("9")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_10"
    }
  }, [_vm._v("10")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Salvation Army Australia Museum")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The Heritage Centre & Archives of The Salvation Army NZFTS "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent5"
  }, [_vm._v("The author’s own collection "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_11"
    }
  }, [_vm._v("11")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_12"
    }
  }, [_vm._v("12")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" & "), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', {
    staticClass: "head1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wikimedia Commons")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1#page_1"
    }
  }, [_vm._v("1.")])]), _vm._v(" Author Unknown c1862; William-booth-c1862; Public Domain UK "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www2.salvationarmy.org.uk/uki/www_uki.nsf/vw-sublinks/CFD47158EBB37A4E802570A60042A18B?openDocument",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www2.salvationarmy.org.uk/uki/www_uki.nsf/vw-sublinks/CFD47158EBB37A4E802570A60042A18B?openDocument")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")])]), _vm._v(" Author Edward King 1886; Descriptive portraiture of Europe in storm and calm; twenty years’ experiences and reminiscences "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("of an American journalist, sketches and records of noted events, celebrated persons and places "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.flickr.com/photos/internetarchivebookimages/14596077037",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.flickr.com/photos/internetarchivebookimages/14596077037")])])]), _vm._v("/")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18.")])]), _vm._v(" Author Dorothy McCulla 1887; Victorian and Edwardian Birmingham; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28.")])]), _vm._v(" Author Enric 2014; Edinburgh – Salvation Army Women’s Hostel, Grassmarket, Edinburgh; CC BY-SA 4.0")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter2#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32.")])]), _vm._v(" Author Robertoalonsomen 2019; Strawberry Fields; Creative Commons Attribution-Share Alike 4.0")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52.")])]), _vm._v(" Author Bains News Service 1910-15; Bramwell Booth; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53.")])]), _vm._v(" Unknown Author; William Thomas Stead; Public Domain Mark 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55.")])]), _vm._v(" Unknown Author 1893; Members of the Matchmakers’ Union; Wellcome Library London; Attribution 4.0 International (CCBY 4.0)")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter3#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61.")])]), _vm._v(" Unknown Author 1917-18; Medical Department – First Aid – Ambulance Service – Types – Salvation Army ambulance; National Archives and Records Administration, catalogued under the National Archives Identifier (NAID) 45494166; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69.")])]), _vm._v(" Author Bains News Service 1915; Salvation Army feeding Berlin children; Library of Congress’s Prints and Photographs division under the digital ID ggbain.30603; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71.")])]), _vm._v(" Author Greg Henshall 2008; Salvation Army food truck in Iowa; FEMA Photo Library; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73.")])]), _vm._v(" Author Hugo van Gelderen / Anefo 1963; Brand bij C en A te Amsterdam. Heilsoldaten van het Leger des Heils schenken kof; CCO 1.0 Universal; Public Domain Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76.")])]), _vm._v(" Unknown Author 1907; General Booth 16 July 1907; "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.flickr.com/photos/40222405@N03/6441286491",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.flickr.com/photos/40222405@N03/6441286491")])])]), _vm._v("/; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter4#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78.")])]), _vm._v(" Author Bains News Service 1914; Japanese in parade; Library of Congress’s Prints and Photographs division under the digital ID ggbain.16422; Public Domain")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "listpad"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110.")])]), _vm._v(" Author Oxfordian Kissuth 2015; The Salvation Army International Headquarters; Creative Commons Attribution-Share Alike 3.0")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111.")])]), _vm._v(" Frederick Duncan 1919; A man may be down but he’s never out; Library of Congress’s Prints and Photographs division under the digital ID cph.3g10026")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "listpad"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter5#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112.")])]), _vm._v(" John Pughe 1897; No rest for the wicked; Library of Congress’s Prints and Photographs division under the digital ID ppmsca.28817")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1239f11f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Credits.vue
// module id = 75
// module chunks = 0